import { RequireAccess } from '@/components'
import { AssetHubPage } from '@/managers'
import { SettingsNav } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/asset-hub',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const { t } = useTranslation('common')

	return (
		<SettingsNav active="asset-hub" fullWidth={true} fixedHeight={true}>
			<div className="h-full">
				<RequireAccess
					permission="media:read"
					fallback={
						<p className="p-4 text-sm text-gray-500">
							{t('settings.campaignSettings.noPermission')}
						</p>
					}
				>
					<AssetHubPage />
				</RequireAccess>
			</div>
		</SettingsNav>
	)
}
